import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { ProviderModel } from '../../models/provider';

const getOtherProviderIdsBySpecialtyIdSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<ProviderModel>) => memoize((
        specialtyId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => specialtyId && !byId[x]!.specialtyIds.includes(specialtyId))
        .map(x => +x)
    )
);

const getProviderIdsBySpecialtyIdSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<ProviderModel>) => memoize((
        specialtyId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => !specialtyId || byId[x]!.specialtyIds.includes(specialtyId))
        .sort((a, b) => {
            const lastNameLowerA = (byId[a]!.lastName || '').toLowerCase();
            const lastNameLowerB = (byId[b]!.lastName || '').toLowerCase();
            if (lastNameLowerA === lastNameLowerB) {
                return (byId[a]!.firstName || '').toLowerCase() > (byId[b]!.firstName || '').toLowerCase() ? 1 : -1;
            } else {
                return lastNameLowerA > lastNameLowerB ? 1 : -1;
            }
        })
        .map(x => +x)
    )
);

export const selectors = {
    getOtherProviderIds: (
        state: State,
        ids: Undefinable<number>[]
    ): number[] => ids.filter(x => x && !state.byId[x]) as number[],
    getOtherProviderIdsBySpecialtyId: (
        state: State,
        specialtyId: Undefinable<number>
    ): number[] => getOtherProviderIdsBySpecialtyIdSelector(state)(specialtyId),
    getProvider: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<ProviderModel> => state.byId[id || ''],
    getProviderIds: (
        state: State
    ): number[] => state.allIds,
    getProviderIdsBySpecialtyId: (
        state: State,
        specialtyId: Undefinable<number>
    ): number[] => getProviderIdsBySpecialtyIdSelector(state)(specialtyId)
};
